import React, { useEffect } from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useT } from '../i18n/useT';

const NotFoundPage: React.FC = () => {
  const { r } = useT();

  useEffect(() => {
    document.title = '404 · WAI';
    const meta = document.querySelector('meta[name="robots"]');
    if (meta) meta.setAttribute('content', 'noindex, follow');
    return () => {
      if (meta) meta.setAttribute('content', 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1');
    };
  }, []);

  return (
    <Box
      component="main"
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        backgroundColor: 'rgb(13, 13, 37)',
        color: 'white',
        pt: '80px',
      }}
    >
      <Container maxWidth="sm" sx={{ textAlign: 'center' }}>
        <Typography
          sx={{
            fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
            fontSize: '0.85rem',
            letterSpacing: '0.15em',
            color: 'rgba(255, 255, 255, 0.55)',
            mb: 2,
          }}
        >
          ERROR · 404
        </Typography>
        <Typography
          variant="h1"
          sx={{
            fontWeight: 800,
            fontSize: { xs: '2rem', md: '2.8rem' },
            mb: 2,
            letterSpacing: '-0.02em',
          }}
        >
          Página no encontrada
        </Typography>
        <Typography sx={{ color: 'rgba(255, 255, 255, 0.7)', mb: 4, lineHeight: 1.6 }}>
          Lo que buscas se ha movido o no existe. Vuelve al overview y desde ahí encontrarás todas las capacidades de WAI.
        </Typography>
        <Button
          component={RouterLink}
          to="/"
          size="large"
          sx={{
            px: 4,
            py: 1.5,
            borderRadius: '50px',
            background: 'linear-gradient(45deg, #00F5FF, #FF00FF)',
            color: 'white',
            fontWeight: 700,
            textTransform: 'none',
          }}
        >
          {r.routes.fullPlatformCard.cta}
        </Button>
      </Container>
    </Box>
  );
};

export default NotFoundPage;
